module.exports = __webpack_public_path__ + "media/images/icons/outlined/one-to-one-cbdd5861fca54fe11f02a151c2805d1d.svg";